import React, { useState, useEffect } from 'react';
import './App.css';
import AsciiComponent from './ascii';
import VoiceMemos from './VoiceMemos';
import Photos from './Photos';

function App() {
  const [showVoiceMemos, setShowVoiceMemos] = useState(false);
  const [showPhotos, setShowPhotos] = useState(false);

  const goToHome = () => {
    setShowVoiceMemos(false);
    setShowPhotos(false);
  };

  // Keyboard navigation - only go home if no modal is open
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        // Only go home if we're not in a section (let sections handle their own escape)
        if (!showVoiceMemos && !showPhotos) {
          // Do nothing - we're already on home
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showVoiceMemos, showPhotos]);
  
  return ( 
    <div className='App'>
      <table style={{width: '100%', maxWidth: '550px', margin: '0 auto'}} border="0" cellPadding="0" cellSpacing="0">
        <tbody>
        <tr>
          <td>
            {!showVoiceMemos && !showPhotos && (
              <div>
                <AsciiComponent/>
                <hr style={{border: 'none', height: '1px', backgroundColor: '#000'}} />
                
                <p style={{fontSize: '16px'}}><a href="https://github.com/f1lth">swe</a> interested in ai, aesthetics, architecture, trading</p>
                <hr style={{border: 'none', height: '1px', backgroundColor: '#000'}} />
              </div>
            )}

            {!showVoiceMemos && !showPhotos ? (
              <div>
                <div className='content'>
                  <h2>Working on</h2>
                  <ul>
                    <li><a href="https://bitrecs.ai">Bitrecs</a> - Intelligent ecommerce product recommendations powered by Bittensor</li>
                    <li>Trading and not blowing up my account</li>
                    <li>Training Muay Thai in Bangkok</li>
                  </ul>
                </div>
                
                <div className='content'>
                  <h2>Photos</h2>
                  <ul>
                    <li>
                      <button onClick={() => setShowPhotos(true)} className="raw-link" style={{background: 'none', border: 'none', padding: 0, color: '#0000FF', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'serif', fontSize: '16px'}} title="View photo gallery">
                        Photos
                      </button>
                    </li>
                  </ul>
                </div>

                <div className='content'>
                  <h2>Voice Memos</h2>
                  <ul>
                    <li>
                      <button onClick={() => setShowVoiceMemos(true)} className="raw-link" style={{background: 'none', border: 'none', padding: 0, color: '#0000FF', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'serif', fontSize: '16px'}} title="View voice memos collection">
                        Voice memos
                      </button>
                    </li>
                  </ul>
                </div>
                
                <div className='content'>
                  <h2>Contact</h2>
                  <ul>
                    <li>root@f1lth.ca</li>
                  </ul>
                </div>
              </div>
            ) : showVoiceMemos ? (
              <div>
                <VoiceMemos onGoHome={goToHome} />
               </div>
            ) : showPhotos ? (
              <div>
                <Photos onGoHome={goToHome} />
              </div>
            ) : null}

            <hr style={{border: 'none', height: '1px', backgroundColor: '#000'}} />
            <p className="footer-text">
              &copy; 2025 TM pending f1lthcorp 
            </p>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
}

export default App;
